import { Component, OnInit } from '@angular/core';
import { PreferenceModel } from '../models/preference.model';
import { ActivatedRoute, Router } from '@angular/router';
import { PreferenceService } from '../../services/preference.service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-email-preferences',
  templateUrl: './email-preferences.component.html',
  styleUrls: ['./email-preferences.component.scss']
})
export class EmailPreferencesComponent implements OnInit {

  preferenceData: PreferenceModel[];
  token: string;
  queryParams: any;
  paramAvailability: boolean = true;
  constructor(
    private preferenceService: PreferenceService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('code');
    if (!this.token || this.token === undefined || this.token.length === 0) {
      this.paramAvailability = false;
      this.router.navigate(['page-not-found']);
    }
    this.preferenceService.getPreference(this.token)
      .subscribe((data: PreferenceModel[]) => {
        this.fuseSplashScreenService.hide();
        this.preferenceData = data;
      });
  }

  updatePreference() {
    this.preferenceService.setPreference(
      {
        code: this.token,
        preferences: this.preferenceData
      })
      .subscribe((data: PreferenceModel[]) => {
        this.preferenceData = data;
      });
    this.router.navigate(['/user-consent/UpdatePreference/update-successful']);
  }

  handleEmailClick(event, index) {
    this.preferenceData[index].emailInboxEnabled = event.checked;
  }

  handleOrbitaxClick(event, index) {
    this.preferenceData[index].orbitaxInboxEnabled = event.checked;
  }

}
